var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 32,
    rx: 8,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8688 10.8688C19.0164 10.716 19.1929 10.5941 19.3881 10.5103C19.5834 10.4264 19.7933 10.3823 20.0058 10.3804C20.2182 10.3786 20.4289 10.4191 20.6255 10.4995C20.8222 10.58 21.0008 10.6988 21.151 10.849C21.3013 10.9992 21.4201 11.1779 21.5005 11.3745C21.581 11.5711 21.6214 11.7818 21.6196 11.9943C21.6177 12.2067 21.5736 12.4167 21.4898 12.6119C21.4059 12.8071 21.284 12.9836 21.1312 13.1312L20.4968 13.7656L18.2344 11.5032L18.8688 10.8688ZM17.1032 12.6344L10.4 19.3376V21.6H12.6624L19.3664 14.8968L17.1024 12.6344H17.1032Z",
    fill: "#6B7280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.afd797100da5732e87b613513e1a7f31.svg";
export { ForwardRef as ReactComponent };